import Fade from '@mui/material/Fade';
import React, { useState, useMemo, useEffect } from 'react';
import { Provider } from 'react-redux';
import Form from '../../components/form/Form';
import MultiStepForm from '../../components/form/MultiStepForm';
import SingleStepForm from '../../components/form/SingleStepForm';
import { store } from '../../components/form/formStore';

const FormContainer = ({ data, contact, account, questions, onSubmit }) => {
  const [currentIndex, setCurrentIndex] = useState(
    contact && questions.length > 3 ? 3 : 0,
  );
  const totalSteps = questions.length;
  const isLast = totalSteps - 1 === currentIndex;
  const progress = Math.round((currentIndex * 100) / totalSteps);

  useEffect(() => {
    if (contact) {
      const initialValues = questions.reduce((acc, question) => {
        switch (question.question_type) {
          case 'name': {
            acc[question.hash] = {
              firstName: {
                name: `${question.hash}.firstName`,
                value: contact.contact_first_name,
                touched: false,
              },
              lastName: {
                name: `${question.hash}.lastName`,
                value: contact.contact_last_name,
                touched: false,
              },
            };
            break;
          }
          case 'email': {
            acc[question.hash] = {
              value: contact.contact_email,
              name: question.hash,
              touched: false,
            };
            break;
          }
          case 'phone': {
            acc[question.hash] = {
              value: contact.primary_phone,
              name: question.hash,
              touched: false,
            };
            break;
          }
        }
        return acc;
      }, {});
      store.dispatch({
        type: 'save_fields',
        payload: initialValues,
        touched: false,
      });
    }
  }, []);

  const submitForm = () => {
    return onSubmit(store.getState().form);
  };
  const onNext = () => {
    if (!isLast) {
      setCurrentIndex(currentIndex + 1);
    } else {
      return submitForm();
    }
  };

  const onPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const setStep = (index) => {
    setCurrentIndex(index);
  };

  const initialValues = useMemo(() => {}, []);

  return (
    <Provider store={store}>
      <Fade in timeout={800}>
        <div>
          <Form>
            {data.card_type === 'standard' && (
              <SingleStepForm
                initialValues={initialValues}
                account={account}
                questions={questions}
                handleSubmit={submitForm}
              />
            )}
            {data.card_type === 'multistep' && (
              <MultiStepForm
                onQuestionChange={setStep}
                initialValues={initialValues}
                account={account}
                currentIndex={currentIndex}
                setStep={onNext}
                onPrev={onPrev}
                progress={progress}
                questions={questions}
                isLast={isLast}
              />
            )}
          </Form>
        </div>
      </Fade>
    </Provider>
  );
};

export default FormContainer;
